import Campaigns from "./campaigns";
import AddCampaign from "./add-campaign";
import ViewCampaign from "./view-campaign";
import CampaignPayments from "./campaign-payments";

export default {Campaigns, AddCampaign, ViewCampaign, CampaignPayments};